export default __webpack_public_path__ + "src/images/packages/villa-54-victoria/822741887888d5bb8491fcab89480e9c-4.jpg";